import { TableComponent } from "../../../../../components/Table/TableComponent";
import { ConfigurePanel } from "./ConfigurePanel/ConfigurePanel";
import { PieChart } from "../../../../../components/CHARTS/Pie/PieChart";
import { XyChart } from "../../../../../components/CHARTS/Xy/XyChart";
import { KpiChart } from "../../../../../components/CHARTS/Kpi/KpiChart";

export const panelContentMap = {
  ConfigurePanel,
  TableComponent,
  PieChart,
  XyChart,
  KpiChart,
};
